import React, { useState } from "react";
import { useQuery } from "react-query";
import { QK } from "../../../../../../base/qk";
import { useParams } from "react-router-dom";
import { getNEWS2 } from "../../../../../../api/services/observations";
import TableComponent from "../../../../../TableComponent/TableComponent";
import { formatDateTime } from "../../../../../../base/FormatTime";
import { Chip } from "@mui/material";
import { getRiskLevelColor } from "./news2.config";

const ClientNews2List = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { id: clientID } = useParams();

  const resultPerPage = 10;

  const { data: news2lists, isLoading } = useQuery(
    [QK.NEWS2lists, currentPage, clientID],
    () => getNEWS2(currentPage, clientID),
    { keepPreviousData: true, enabled: !!currentPage || !!clientID }
  );

  const totalRecords = news2lists?.count || 0;
  const totalPages = Math.ceil(totalRecords / resultPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const columns = [
    {
      field: "actioned_time",
      headerName: " Date / Time",
      render: (value) => formatDateTime(value),
    },
    { field: "score", headerName: "Score" },
    {
      field: "risk_level",
      headerName: "Risk Level",
      render: (value) => (
        <Chip label={value} color={getRiskLevelColor(value)} size="small" />
      ),
    },
    { field: "notes", headerName: "Notes" },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={news2lists?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="medium"
      />
    </div>
  );
};

export default ClientNews2List;
